export type HorariosSubTab = 'atencion' | 'pagos';

/** Rango horario adicional de un día (después del start/end base). */
export interface DayTimeRange {
  id?: string | number;
  startTime: string;
  endTime: string;
}

export interface DaySchedule {
  enabled: boolean;
  startTime: string;
  endTime: string;
  /** Rangos extras del día (API `ranges[1..n]`). */
  extraRanges?: DayTimeRange[];
}

export interface WeekSchedule {
  lunes: DaySchedule;
  martes: DaySchedule;
  miercoles: DaySchedule;
  jueves: DaySchedule;
  viernes: DaySchedule;
  sabado: DaySchedule;
  domingo: DaySchedule;
}

export interface HolidayEntry {
  id: string | number;
  month: string;
  day: string;
  name: string;
  worksOnHoliday: boolean;
  workStartTime: string;
  workEndTime: string;
}

export interface SpecialSchedule {
  id: string | number;
  date: string;
  startTime: string;
  endTime: string;
  applyEveryYear: boolean;
}

export interface NominatimResult {
  place_id: number;
  display_name: string;
  lat: string;
  lon: string;
}

export type WeekDayKey = keyof WeekSchedule;

export interface WeekDayOption {
  key: WeekDayKey;
  label: string;
}

export const createEmptyDay = (): DaySchedule => ({
  enabled: false,
  startTime: '',
  endTime: '',
  extraRanges: [],
});

export const createEmptyWeek = (): WeekSchedule => ({
  lunes: createEmptyDay(),
  martes: createEmptyDay(),
  miercoles: createEmptyDay(),
  jueves: createEmptyDay(),
  viernes: createEmptyDay(),
  sabado: createEmptyDay(),
  domingo: createEmptyDay(),
});

/** Alias para compatibilidad — usar createEmptyDay/createEmptyWeek en código nuevo */
export const emptyDay = createEmptyDay;
export const emptyWeek = createEmptyWeek;

export const weekDays: WeekDayOption[] = [
  { key: 'lunes', label: 'Lunes' },
  { key: 'martes', label: 'Martes' },
  { key: 'miercoles', label: 'Miércoles' },
  { key: 'jueves', label: 'Jueves' },
  { key: 'viernes', label: 'Viernes' },
  { key: 'sabado', label: 'Sábado' },
  { key: 'domingo', label: 'Domingo' },
];
